import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Wrapper = styled.div`
  contain: layout style;
  width: 100%;
  height: 100%;
  //position: relative;
  ${props =>
    props.depth !== 0 &&
    `
    will-change: transform;
  `};
`;

class ParallaxElement extends Component {
  elID = null;

  static propTypes = {
    Tag: PropTypes.string,
    children: PropTypes.any,
    className: PropTypes.string,
    depth: PropTypes.number.isRequired,
    topAlign: PropTypes.bool,
    inViewCallback: PropTypes.func,
    inViewOnce: PropTypes.bool,
  };

  static defaultProps = {
    Tag: 'div',
    depth: 0,
    inViewOnce: true,
  };

  static contextTypes = {
    registerElement: PropTypes.func.isRequired,
    unregisterElement: PropTypes.func.isRequired,
  };

  componentDidMount = () => {
    const { depth, topAlign, inViewCallback, inViewOnce } = this.props;
    this.elID = this.context.registerElement(
      this.el,
      this.nestedEl,
      depth,
      topAlign,
      inViewCallback,
      inViewOnce
    );
  };

  componentWillUnmount = () => {
    this.context.unregisterElement(this.elID);
  };

  boundRef = el => {
    this.el = el;
  };

  innerRef = el => {
    this.nestedEl = el;
  };

  render() {
    const { Tag, children, className, depth } = this.props;

    return (
      <Tag className={className} ref={this.boundRef}>
        <Wrapper innerRef={this.innerRef} depth={depth}>
          {children}
        </Wrapper>
      </Tag>
    );
  }
}

export default ParallaxElement;



// WEBPACK FOOTER //
// ./src/modules/parallax/components/ParallaxElement.js